import React, { Component } from 'react'
import { Select, Input } from 'antd'
import PropTypes from 'prop-types'
import { app } from '../app'

const Option = Select.Option

class ReviewSearch extends Component {
    constructor(props) {
        super(props)
        // console.log(props)
        this.state = {
            search_type: props.defaultValue || 'searchform_name'
        }
    }

    componentDidMount() {
        this._isMounted = true
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 搜索选择修改
     * @param search_type
     */
    handleSelectChange = (search_type) => {
        this.setData({ search_type })
    }

    /**
     * 搜索
     * @param value
     */
    handleSearch = (value) => {
        this.props.onSearch(this.state.search_type, value)
    }

    render() {
        let { options, type, notBorder } = this.props, { search_type } = this.state
        if (!(options instanceof Array)) {
            switch (type) {
                case 'team':
                    options = [
                        { value: 'searchform_name', text: '队伍名称' },
                        { value: 'searchform_code', text: '队伍编号' },
                    ]
                    break
                case 'new':
                    options = [
                        { value: 'searchform_name', text: '发布人' },
                        { value: 'searchform_title', text: '新闻标题' },
                    ]
                    break
                case 'message':
                    options = [
                        { value: 'searchform_name', text: '发布人' },
                        { value: 'searchform_title', text: '标题' },
                    ]
                    break
                case 'train-sign':
                    options = [
                        { value: 'searchform_name', text: '姓名' },
                        { value: 'searchform_code', text: '存心编号' }
                    ]
                    break
                case 'train-sign-class':
                    options = [
                        { value: 'searchform_name', text: '姓名' },
                        { value: 'searchform_code', text: '存心编号' },
                        { value: 'searchform_class', text: '班级名称' },
                    ]
                    break
                case 'honor-wall-user':
                    options = [
                        { value: 'searchform_honorname', text: '荣誉名称' },
                        { value: 'searchform_name', text: '队员名称' },
                        { value: 'searchform_bsrno', text: '存心编号' },
                    ]
                    break
                case 'honor-wall-team':
                    options = [
                        { value: 'searchform_honorname', text: '荣誉名称' },
                        { value: 'searchform_teamname', text: '队伍名称' },
                    ]
                    break
                case 'honor-wall-team_p':
                    options = [
                        { value: 'searchform_honorname', text: '荣誉名称' },
                    ]
                    break
                case 'note-buy':
                    options = [
                        { value: 'searchform_name', text: '购买人姓名' },
                        { value: 'searchform_code', text: '购买人编号' },
                    ]
                    break
                default:
                    options = [
                        { value: 'searchform_name', text: '队员姓名' },
                        { value: 'searchform_code', text: '队员编号' },
                    ]
            }
        }
        let border = {
            width: 114,
            padding: '0 10px',
            boxSizing: 'initial'
        }
        if (!notBorder) {
            border.borderTop = '1px solid #d9d9d9'
            border.borderBottom = '1px solid #d9d9d9'
            border.borderLeft = '1px solid #d9d9d9'
            border.borderRight = 'none'
            border.borderTopLeftRadius = 4
            border.borderBottomLeftRadius = 4
        }
        return (
            <span style={{ margin: '0 30px' }} className='review-search'>
                <Input.Search
                    placeholder="输入关键词搜索"
                    enterButton="搜索"
                    onSearch={this.handleSearch}
                    style={{ width: 400 }}
                    addonBefore={
                        <Select style={border} value={search_type}
                            onChange={this.handleSelectChange}>
                            {
                                options.map((o, i) => {
                                    return (
                                        <Option key={i} value={o.value}>{o.text}</Option>
                                    )
                                })
                            }
                        </Select>
                    }
                />
            </span>
        )
    }
}

ReviewSearch.propTypes = {
    onSearch: PropTypes.func.isRequired,
    defaultValue: PropTypes.string,
}

export default ReviewSearch



// WEBPACK FOOTER //
// ./src/components/ReviewSearch.jsx